/**
 * Internal Dependencies
 */
import LogoUrl from "./components/logo-url.js";
import PrimaryNav from "./components/primary-nav.js";
import Isi from "./components/isi";
import OffsiteModal from "./components/offsite-modal.js";
import themeOptions from "./components/theme-options";
import portfolioDropdown from "./components/portfolio-dropdown";
import lottieAnimations from "./components/lottie-animations";
import accordions from "./components/accordions";
import tabsDropdown from "./components/tabs-dropdown.js";
import providerForm from "./components/provider-form.js";
import "../scss/main.scss";
import "./vendor/match.js";

var primaryNav = new PrimaryNav();
var logoUrl = new LogoUrl();
var isi = new Isi();
var offsiteModal = new OffsiteModal();

(function () {
    themeOptions();
    portfolioDropdown();
    lottieAnimations();
    accordions();
    tabsDropdown();
    providerForm();

    let $ = jQuery;

    $(".match").matchHeight();

    if (window.location.pathname.startsWith("/hcp/")) {
        if (getCookie("hcp_conf") !== "true") {
            hcpConfirmationModal();
        }
    }
})();

function hcpConfirmationModal() {
    // Base path setup for lottie files
    // Check if site is local, or if it's on WP Engine staging using contains
    let hcpBasePath = "";
    if (
        window.location.href.indexOf("belotero.local") > -1 ||
        window.location.href.indexOf("beloterostg.wpenginepowered.com") > -1
    ) {
        hcpBasePath = "/wp-content/themes/mtpress/parts/hcp-modal.html";
    } else {
        hcpBasePath = "/app/themes/mtpress/parts/hcp-modal.html";
    }

    jQuery.get(
        hcpBasePath,
        function (data) {
            jQuery("body").append(data);

            // Add your event listeners after the modal content is loaded.
            hcpAddEventListeners();
        }
    );
}

function hcpAddEventListeners() {
    // Add event listeners here
    jQuery(".form-button.close").on("click", function (e) {
        e.preventDefault();
        setCookie("hcp_conf", "true", 7);
        jQuery("#hcp-modal").remove();
    });
}

function setCookie(name, value, days) {
    const expires = new Date();
    expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
}

function getCookie(name) {
    const cookieName = `${name}=`;
    const cookieArray = document.cookie.split(";");

    for (let i = 0; i < cookieArray.length; i++) {
        let cookie = cookieArray[i];
        while (cookie.charAt(0) === " ") {
            cookie = cookie.substring(1);
        }
        if (cookie.indexOf(cookieName) === 0) {
            return cookie.substring(cookieName.length, cookie.length);
        }
    }
    return null;
}
